import useSWR from "swr";

import { fetcher } from "../model/fetcher";
import { ApiComponentType } from "@store/types";
import { ApiIncidentType } from "@store/types";
import { ApiPageType } from "@store/types";
import { ApiScheduledMaintenanceType } from "@store/types";
import { ApiStatusType } from "@store/types";

type SummaryType = {
    components: ApiComponentType[];
    page: ApiPageType;
    status: ApiStatusType;
    incidents: ApiIncidentType[];
    scheduled_maintenances: ApiScheduledMaintenanceType[];
};

export const useSummaryData = () => {
    const { data, error, isLoading } = useSWR<SummaryType>("/summary.json", fetcher, {
        refreshInterval: 3000,
    });

    return { data, error, isLoading };
};
